import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findTabulateList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/tabulate?` + params,
        method: 'GET'
    })
}
export const findTabulateList2 = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/tabulate2?` + params,
        method: 'GET'
    })
}
export const findTabulateList2DownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/tabulate2Excel?` + params,
        method: 'GET'
    })
}